import { ProductConfiguration } from "@domain/project/configurations/product-configuration";
import { MonitoringProductData } from "@domain/project/monitoring-product-data/monitoring-product-data";

export class MonitoringConfigProductMap {
  placedProductsCount: number = 0;
  additionalProductsCount: number = 0;
  config: ProductConfiguration;
  data: MonitoringProductData[];

  constructor(config: ProductConfiguration, data: MonitoringProductData[], count: number) {
    this.config = config;
    this.data = data;
    this.placedProductsCount = count;
    this.additionalProductsCount = config.additionalProductListQuantity;
  }

  get totalProductsCount() {
    return this.placedProductsCount + this.additionalProductsCount;
  }

  private getSuffixLetter(positionId: string): string {
    const parts = positionId.split(".");
    return parts[1]?.toLowerCase() ?? "";
  }
}
